import React from "react";

const Portfolio = ({ data }) => {
  if (!data || data.length === 0) {
    return null;
  }

  return (
    <section id="work" className="work-section section-shell">
      <div className="section-heading-row" data-reveal>
        <div>
          <p className="section-kicker">Selected work</p>
          <h2>Products built for real transactions and real users.</h2>
        </div>
        <p className="section-support">
          From payment infrastructure to consumer finance, I turn difficult
          product requirements into dependable, maintainable systems.
        </p>
      </div>

      <div className="project-grid">
        {data.map((project, index) => {
          const links = project.links || [
            { label: "View project", url: project.link },
          ];

          return (
            <article
              className="project-card"
              key={project.name}
              data-reveal
              style={{ "--reveal-delay": `${index * 90}ms` }}
            >
              <div className="project-card-topline">
                <span>0{index + 1}</span>
                <span>{project.type}</span>
              </div>
              <h3>{project.name}</h3>
              <p>{project.description}</p>
              <ul>
                {project.outcomes.map((outcome) => (
                  <li key={outcome}>{outcome}</li>
                ))}
              </ul>
              <div className="project-links">
                {links.map((link) => (
                  <a
                    href={link.url}
                    key={link.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="project-link"
                  >
                    {link.label}
                  </a>
                ))}
              </div>
            </article>
          );
        })}
      </div>
    </section>
  );
};

export default Portfolio;
